import {defineMessages} from 'react-intl';

export default defineMessages({
  informationMessage: {
    defaultMessage: 'Your progress will be automatically saved when you close this digital lab.',
    id: 'DigitalLab.ControlBar.CloseLabButton.InformationMessage',
  },
});
